module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin_cyrillic-regular.0421ddd7.eot";